import { useInfiniteQuery } from '@tanstack/react-query';

import {
  formatInfiniteRelationship,
  getNextPageParam,
} from 'components/helpers/reactQuery';

export function useInfiniteProjectsAnalyticsProjectsReportsCurrentProjectsReportsDashboardReportQuery({
  params = {},
  queryOptions,
}) {
  return useInfiniteQuery({
    queryKey: [
      'projectsReports',
      'dashboardReports',
      'projectsAnalytics',
      'currentProjectsReports',
      params,
    ],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await axios.post(
        '/projects_analytics/projects_reports/current_projects_reports/dashboard_reports',
        { dashboard_report: { ...params, page: pageParam } },
      );

      return response.data;
    },
    getNextPageParam,
    select: (data) =>
      formatInfiniteRelationship({
        data,
        relationshipKey: 'projects',
        resourceTypes: [
          'company',
          'field',
          'folder',
          'project',
          'projectContentReviewRequest',
          'user',
        ],
      }),
    ...queryOptions,
  });
}
